import restUrls from "web/constants/restUrls";

import {
  BankItems,
  BankPartialDischargeItems,
  BankResetItems,
} from "web/types/Banks";

import { AppDispatch } from "web/store";

import api from "../api/apiSlice";
import translateAndTransformBanks from "./utils/translateAndTransformBanks";

interface IPointsBank {
  items: BankItems;
  itemsActive: BankItems;

  total: number;
}

export const pointsBankApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getBanks: builder.query<IPointsBank, void>({
      queryFn: async (_, arg, _extraOptions, fetchWithBQ) => {
        const dataBanks = (await fetchWithBQ(`${restUrls.pointsBank}`)) as {
          data?: IPointsBank;
          error?: { status: number; data: { message: string } };
        };

        if (dataBanks?.error) {
          return { error: dataBanks.error };
        }

        const { items } = (dataBanks?.data as { items: BankItems }) || {};

        const [{ items: itemsTransformed, total, itemsActive }] =
          (await Promise.all([translateAndTransformBanks(items)])) as [
            { items: BankItems; itemsActive: BankItems; total: number }
          ];

        return {
          data: {
            items: itemsTransformed,
            itemsActive,
            total,
          },
        };
      },
      providesTags: ["PointsBank"],
    }),
    getResetPointsBank: builder.query<BankResetItems, void>({
      query: () => ({
        url: `${restUrls.resetPointsBank}?days=42`,
      }),
      transformResponse: (response: { singleResets: BankResetItems }) => {
        return response.singleResets;
      },
      providesTags: ["ResetPointsBank"],
    }),
    getItemsDischarge: builder.query<BankPartialDischargeItems, void>({
      query: () => ({
        url: `${restUrls.partialDischargeBank}`,
      }),
      providesTags: ["PartialDischargeBank"],
    }),
  }),
});

export const invalidateBanks = (dispatch: AppDispatch) =>
  dispatch(pointsBankApiSlice.util.invalidateTags(["PointsBank"]));
export const getBanksForce = (dispatch: AppDispatch) =>
  dispatch(
    pointsBankApiSlice.endpoints.getBanks.initiate(undefined, {
      forceRefetch: true,
    })
  );
export const {
  useGetBanksQuery,
  useGetResetPointsBankQuery,
  useGetItemsDischargeQuery,
} = pointsBankApiSlice;
